if ($('#modal-introductory-lesson').length) {
  if (!sessionStorage.getItem('modal-introductory-lesson')) {
    setTimeout(function () {
      sessionStorage.setItem('modal-introductory-lesson', true)
      $('.modal-introductory-lesson').css( "display", "block" )
    }, 3000)
  }
}

$(document).on('click', '.js-modalClose_introductory-lesson', function(event) {
  event.preventDefault();
  $('.modal-introductory-lesson').css( "display", "none" )
});
